var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:{ mobileApp: _vm.isMobile() },attrs:{"id":"app"}},[_c('v-app',[_c('router-view'),_c('notifications',{class:{ mobile: _vm.isMobile() },attrs:{"id":"notifGp","position":"top right","group":"notif"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }